'use strict';

const $navigation = $('.c-navbar');
const $toggle = $('.c-header__menu-toggle');
const $overlay = $('.c-header__overlay');
const $body = $(document);
const $subitem = $('.c-navbar__item--has-submenu');
const $window = $(window);
const $desktopBreakpoint = 992;

$toggle.on('click', function(e) {

    if($window.width() < $desktopBreakpoint) {
        e.preventDefault();

        // show overlay and position it.
        const offset = $('.c-header__left-content').outerHeight();
        const height = $body.height() - offset;
        $overlay.css({
            'height': height + 'px'
        });

        // remove all active/open class in menu
        if($(this).hasClass('is-active')) {
            $navigation.removeClass('is-open is-open-l2');
            $navigation.find('.is-open').removeClass('is-open');
            $navigation.find('.is-active').removeClass('is-active');
        }

        toggleMenu();
    }
});

$subitem.on('click', function(e) {

    if($window.width() < $desktopBreakpoint) {

        e.preventDefault();

        const $this = $(this);
        const $subnav = $this.next('.c-navbar__sublist');
        const $parent = $this.parent();

        if($this.hasClass('is-active')) {

            if($parent.hasClass('c-navbar__items--l2')) {
                $navigation.removeClass('is-open-l2');
            } else {
                $navigation.removeClass('is-open');
            }

            $parent.removeClass('is-open');
            $this.removeClass('is-active');
            $subnav.removeClass('is-active');

        } else {

            if($parent.hasClass('c-navbar__items--l2')) {
                $navigation.addClass('is-open-l2');
            }

            $parent.addClass('is-open');
            $navigation.addClass('is-open');
            $this.addClass('is-active');
            $subnav.addClass('is-active');
        }
    }
});

function toggleMenu() {
    $toggle.toggleClass('is-active');
    $navigation.toggleClass('is-active');
    $overlay.toggleClass('is-active--menu');
}



// WEBPACK FOOTER //
// ./src/js/components/menu-toggle.js